import { useConfigQuery } from '@foundershub/api-client';
import { useFeatureFlagEnabled } from '../../store';

export const MFS_REPLATFORM_URL = 'https://portal.azure.com/?homeview=startup#home';

export const MFS_REPLATFORM_FLAG = 'mfsReplatformEnabled';

/**
 * Returns the fwlink URL when MfsReplatformEnabled is on, otherwise returns the fallback (default: '/signup').
 */
export function useSignupUrl(fallback: string = '/signup'): string {
  const enabled = useFeatureFlagEnabled(MFS_REPLATFORM_FLAG);
  return enabled ? MFS_REPLATFORM_URL : fallback;
}

/**
 * Returns true when the MfsReplatformEnabled feature toggle is active.
 */
export function useMfsReplatformEnabled(): boolean {
  return useFeatureFlagEnabled(MFS_REPLATFORM_FLAG);
}

/**
 * Returns whether the config query is still loading (flag value not yet known).
 */
export function useMfsReplatformLoading(): boolean {
  const { isLoading } = useConfigQuery();
  return isLoading;
}
